module.exports = __webpack_public_path__ + "static/media/logo.8d86406a.svg";